const navLinks = [
    {
        name: 'Home',
        link: '/'
    },
    {
        name: 'Games',
        link: '/games'
    },
    {
        name: 'Genres',
        link: '/genres'
    },
    {
        name: 'Platforms',
        link: '/platforms'
    },
    {
        name: 'Stores',
        link: '/stores'
    },
    {
        name: 'About',
        link: '/about'
    },
];

export default navLinks;